//#region
import { useState, useEffect } from "react";

//material
import {
  Grid,
  FormControl,
  InputLabel,
  Select as MSelect,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";

// component
import Controls from "../../controls/Controls";
import { useForm, Form } from "../../useForm";
import {
  getDatasets,
  getAllDataSetsWOAuth,
} from "../../../config/services/datasets";
import { getAllDashboardsWOAuth } from "../../../config/services/dashboards";
import updateConfigRole from "../../../layouts/dashboard/SidebarConfig";
import ReactSelect from "react-select";
import { getSidebarConfig } from "../../../config/services/sidebarConfig";
import { userTypeShare } from "../../../config/services/dashboardShare";
import { getUserType } from "../../../config/services/usertype";
import _ from "lodash";

//#endregion
const initialFValues = {
  _id: 0,
  userTypeName: "",
};

export default function UserTypePopup(props) {
  const { addOrEdit, recordForEdit, handleCloseEditPopup, userTypeList } =
    props;
  const [datasetList, setDatasetList] = useState([]);
  const [datasetAccess, setDatasetAccess] = useState([]);
  const [dashboardList, setDashboardList] = useState([]);
  const [dashboardAccess, setDashboardAccess] = useState([]);
  const [securityContextEnabled, setSecurityContextEnabled] = useState(false);
  const [securityContext, setSecurityContext] = useState({});
  const [accessType, setAccessType] = useState("view");
  const [sideBarMenuAccess, setSideBarMenuAccess] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState([]);
  const [sidebarConfig, setSidebarConfig] = useState([]);
  const [publishDashboard, setPublishDashboard] = useState(false);
  const [customFieldCreation, setCustomFieldCreation] = useState(false);
  const [schoolCodeAuth, setSchoolCodeAuth] = useState(false);
  const [dashboardReportDownload, setDashboardReportDownload] = useState(false);
  const [newUserTypeList, setNewUserTypeList] = useState([]);
  const [exportAuth, setExportAuth] = useState({
    excel: false,
    csv: false,
    pdf: false,
  });

  const fetchDatasetsList = () => {
    let params = { pageNo: 0 };
    getAllDataSetsWOAuth(params).then((res) => {
      setDatasetList([...res?.result]);
    });
  };

  const getSidebarConfigList = () => {
    getSidebarConfig().then((config) => {
      if (config && config.length) {
        const configList = updateConfigRole(config);
        setSidebarConfig(configList);
      }
    });
  };

  const fetchDashboardList = () => {
    let params = {};
    getAllDashboardsWOAuth(params).then((res) => {
      setDashboardList([...res?.result]);
    });
  };

  const fetchUserTypeList = () => {
    let params = {};
    getUserType(params).then((res) => {
      setNewUserTypeList([...res?.result]);
    });
  };

  useEffect(() => {
    getSidebarConfigList();
    fetchDatasetsList();
    fetchDashboardList();
    fetchUserTypeList();
  }, []);

  const setDataAccessValueInital = (value) => {
    let valueList = value?.map((obj) => obj["dataSetName"]);
    if (!valueList) valueList = [];
    setDatasetAccess([...valueList]);
  };

  const setDashboardAccessValueInital = (value) => {
    const data = value?.map((obj) => {
      return dashboardList.find((item) => {
        return obj?.dashboardId == item?._id;
      });
    });

    let valueList = data?.map((obj) => obj?.["dashboardName"]);
    if (!valueList) valueList = [];
    setDashboardAccess([...valueList]);
  };

  const getDashboardId = (namelist) => {
    let dashboardListA = namelist?.map((obj) => {
      let index = dashboardList.findIndex((d) => d["dashboardName"] === obj);
      if (index >= 0) return dashboardList[index]._id;
      else return null;
    });
    return dashboardListA;
  };

  const getDatasetId = (namelist) => {
    let datasetListA = namelist?.map((obj) => {
      let index = datasetList.findIndex((d) => d["dataSetName"] === obj);
      if (index >= 0) return datasetList[index]._id;
      else return null;
    });
    return datasetListA;
  };

  useEffect(() => {
    setDataAccessValueInital(recordForEdit?.datasetAccess);
    setSecurityContextEnabled(recordForEdit?.securityContextEnabled);
    setSecurityContext(recordForEdit?.securityContext);
    setAccessType(recordForEdit?.accessType);
    setSideBarMenuAccess(mapMenuAcccessOnFetch(recordForEdit?.menusAllowed));
    if (
      recordForEdit?.publishDashboard === true ||
      recordForEdit?.publishDashboard === false
    ) {
      setPublishDashboard(recordForEdit?.publishDashboard);
    }
    if (
      recordForEdit?.customFieldCreation === true ||
      recordForEdit?.customFieldCreation === false
    ) {
      setCustomFieldCreation(recordForEdit?.customFieldCreation);
    }
    setSelectedUserType(recordForEdit?.userTypeList);
    if (recordForEdit?.exportAuth) {
      setExportAuth(recordForEdit?.exportAuth);
    }
    setSchoolCodeAuth(recordForEdit?.schoolCodeAuth);
    setDashboardReportDownload(recordForEdit?.dashboardReportDownload);
  }, [recordForEdit]);

  useEffect(() => {
    if (dashboardList.length) {
      setDashboardAccessValueInital(recordForEdit?.dashboardAccess);
    }
  }, [dashboardList]);

  const mapMenuAcccessOnFetch = (menus) => {
    if (!menus) {
      return [];
    }

    let mappedMenus = Array.from(menus);
    mappedMenus?.map((obj) => {
      obj.label = obj.label;
      obj.value = obj.menuId;
      obj.title = obj.menuName;
    });
    return mappedMenus;
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("userTypeName" in fieldValues) {
      temp.userTypeName = fieldValues.userTypeName
        ? ""
        : "This field is required.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      // values.dashboardAccess = getDashboardId(dashboardAccess);
      values.datasetAccess = getDatasetId(datasetAccess);
      values.securityContext = securityContext;
      values.securityContextEnabled = securityContextEnabled;
      // values.accessType = accessType;
      values.customFieldCreation = customFieldCreation;
      values.publishDashboard = publishDashboard;
      values.menusAllowed = mapMenuAcccessSubmit(sideBarMenuAccess);
      values.userTypeList = selectedUserType?.map((list) => list?._id);
      values.schoolCodeAuth = schoolCodeAuth;
      values.exportAuth = exportAuth;
      values.dashboardReportDownload = dashboardReportDownload;
      addOrEdit(values, resetForm);

      let params = {
        // dashboardId, usertypeId, accessType, deleteddashboardId, type
        dashboardId: getDashboardId(dashboardAccess),
        usertypeId: recordForEdit?._id,
        accessType: accessType,
        type: "dashboard",
      };

      const deletedUserTypeIds = recordForEdit.dashboardAccess?.reduce(
        (acc, item) => {
          if (!params.dashboardId?.includes(item?.dashboardId)) {
            acc.push(item?.dashboardId);
          }
          return acc;
        },
        []
      );

      if (deletedUserTypeIds.length) {
        params.deleteddashboardId = deletedUserTypeIds;
      }

      userTypeShare(params).then((res) => {});
    }
  };

  const mapMenuAcccessSubmit = (menus) => {
    let mappedMenus = Array.from(menus);
    mappedMenus.map((obj) => {
      obj.label = obj.label;
      obj.menuId = obj.value;
      obj.menuName = obj.title;
    });
    return mappedMenus;
  };

  const handleEnableSecurityContext = (e) => {
    let { checked } = e.target;

    if (checked === false) {
      setSecurityContext({});
    }

    setSecurityContextEnabled(checked);
  };

  const handleEnableSingleSecurity = (e) => {
    let { value } = e.target;
    setSecurityContext(value);
  };

  const handleAccessChange = (e) => {
    setAccessType(e?.target?.value);
  };

  const changeSidebarMenuAccess = (value) => {
    setSideBarMenuAccess(value);
  };

  const handleUserTypeSelect = (e, value) => {
    const { option, action, removedValue } = value;
    let selected;
    if (action === "remove-value") {
      selected = selectedUserType?.filter(
        (selected) => selected._id !== removedValue?._id
      );
    } else {
      selected = _.cloneDeep(selectedUserType);
      selected?.push(option);
    }
    setSelectedUserType(selected);
  };

  useEffect(() => {
    if (recordForEdit != null) setValues({ ...recordForEdit });
  }, [recordForEdit, setValues]);

  // console.log(newUserTypeList,'................newUserTypeList')

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={8}>
          <Controls.Input
            name="userTypeName"
            label="UserType Name"
            value={values.userTypeName}
            onChange={handleInputChange}
            error={errors.userTypeName}
          />
        </Grid>
        <Grid item xs={8}>
          <Autocomplete
            multiple
            options={datasetList}
            getOptionLabel={(option) => option.dataSetName}
            value={datasetList.filter((item) =>
              datasetAccess.includes(item.dataSetName)
            )}
            onChange={(event, newValue) => {
              setDatasetAccess(newValue.map((item) => item.dataSetName));
            }}
            renderTags={(value) => value.map((v) => v.dataSetName).join(", ")}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Datasets"
                placeholder="Search datasets"
              />
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {option.dataSetName}
              </li>
            )}
            disableCloseOnSelect
          />
        </Grid>

        <Grid item xs={8}>
          <Autocomplete
            multiple
            options={dashboardList}
            getOptionLabel={(option) => option.dashboardName}
            value={dashboardList.filter((item) =>
              dashboardAccess.includes(item.dashboardName)
            )}
            onChange={(event, newValue) => {
              setDashboardAccess(newValue.map((item) => item.dashboardName));
            }}
            renderTags={(value) => value.map((v) => v.dashboardName).join(", ")}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Dashboard"
                placeholder="Search dashboards"
              />
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {option.dashboardName}
              </li>
            )}
            disableCloseOnSelect
          />
        </Grid>

        <Grid item xs={8}>
          <FormControl variant="outlined" sx={{ m: 5, width: 120 }}>
            <InputLabel htmlFor="outlined-age-native-simple">Access</InputLabel>
            <Select value={accessType} onChange={handleAccessChange}>
              <MenuItem value="view">View</MenuItem>
              <MenuItem value="edit">Edit</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
            <Typography
              className="report-form-label"
              variant="subtitle1"
              display="block"
            >
              {" "}
              Menus Access{" "}
            </Typography>
            <ReactSelect
              classNamePrefix="select"
              isMulti
              options={sidebarConfig}
              value={sideBarMenuAccess}
              onChange={changeSidebarMenuAccess}
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={securityContextEnabled} />}
              label="Enable Data Level Security"
              onChange={handleEnableSecurityContext}
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          {securityContextEnabled ? (
            <>
              <FormControl>
                <RadioGroup
                  row
                  name="securityContextType"
                  value={securityContext}
                  onChange={(e) => handleEnableSingleSecurity(e)}
                >
                  <FormControlLabel
                    value="school_code"
                    control={<Radio />}
                    label="School Wise Data"
                    name="schoolContext"
                  />
                  <FormControlLabel
                    value="t_uuid"
                    control={<Radio />}
                    label="Teacher Wise Data"
                    name="classContext"
                  />
                  <FormControlLabel
                    value="s_uuid"
                    control={<Radio />}
                    label="User Wise Data"
                    name="sUuidContext"
                  />
                  <FormControlLabel
                    value="roleName"
                    control={<Radio />}
                    label="HRMS Based Data"
                    name="roleNameContext"
                  />
                </RadioGroup>
              </FormControl>
            </>
          ) : null}
        </Grid>

        <Grid item xs={8}>
          <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
            <Typography
              className="report-form-label"
              variant="subtitle1"
              display="block"
            >
              {" "}
              UserType List{" "}
            </Typography>
            <ReactSelect
              classNamePrefix=""
              isMulti
              options={newUserTypeList?.filter(
                (user) => user?._id !== recordForEdit?._id
              )}
              menuPlacement="auto"
              getOptionLabel={(option) => option?.userTypeName}
              getOptionValue={(option) => option._id}
              value={selectedUserType}
              onChange={handleUserTypeSelect}
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={customFieldCreation} />}
              label="Allow Custom Field Creation/Deletion"
              onChange={(e) => setCustomFieldCreation(e?.target?.checked)}
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={publishDashboard} />}
              label="Allow Publish Dashboard"
              onChange={(e) => setPublishDashboard(e?.target?.checked)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={exportAuth?.pdf} />}
              label="Allow Export PDF"
              onChange={(e) =>
                setExportAuth((prev) => ({ ...prev, pdf: e?.target?.checked }))
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={exportAuth?.csv} />}
              label="Allow Export CSV"
              onChange={(e) =>
                setExportAuth((prev) => ({ ...prev, csv: e?.target?.checked }))
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={exportAuth?.excel} />}
              label="Allow Export Excel"
              onChange={(e) =>
                setExportAuth((prev) => ({
                  ...prev,
                  excel: e?.target?.checked,
                }))
              }
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={schoolCodeAuth} />}
              label="Publish Dashboard to Mapped Roles"
              onChange={(e) => setSchoolCodeAuth(e?.target?.checked)}
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={dashboardReportDownload} />}
              label="Allow Report Download on Dashboard"
              onChange={(e) => setDashboardReportDownload(e?.target?.checked)}
            />
          </FormControl>
        </Grid>

        <Grid item xs={8}>
          <div>
            <Controls.Button type="submit" text="submit" />
            <Controls.Button
              color="error"
              text="Cancel"
              onClick={() => handleCloseEditPopup()}
            />
            {/* <Controls.Button color="secondary" text="Reset" onClick={resetForm} /> */}
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
